var map = {
	"./CSV_exampleImage.jpg": 534,
	"./Circle-white.svg": 1266,
	"./Circle-whitea.svg": 1267,
	"./Confluence_Domain_url.png": 535,
	"./Getting started page media/Check-ins onboarding illustrations/1 Locate Troopr Assistant in Slack.svg": 1268,
	"./Getting started page media/Check-ins onboarding illustrations/2. Submit 1st standup answer.svg": 536,
	"./Getting started page media/Check-ins onboarding illustrations/3. Integrate with Jira.svg": 537,
	"./Getting started page media/Check-ins onboarding illustrations/4. Share Jira context in reports.svg": 538,
	"./Getting started page media/Helpdesk onboarding Emoji/1. Success.svg": 350,
	"./Getting started page media/Helpdesk onboarding Emoji/2. Manage private requests.svg": 539,
	"./Getting started page media/Helpdesk onboarding Emoji/3. Hurray, you made it.svg": 1269,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/1. Setup demo Helpdesk channels.svg": 540,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/2. Check update in support channel.svg": 541,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/3. In App Home.svg": 542,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/4. In DM with agents.svg": 543,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/5. Manage approvals.svg": 544,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/6. Create approval request.svg": 545,
	"./Getting started page media/Helpdesk onboarding Modal illustrations/7. Get notified and take action.svg": 546,
	"./Getting started page media/Project onboarding illustration/1.Setup demo project channel.svg": 547,
	"./Getting started page media/Project onboarding illustration/2. Issue card.svg": 548,
	"./Getting started page media/wiki onboarding illustrations/1. Setup demo wiki channels.svg": 549,
	"./Getting started page media/wiki onboarding illustrations/2. Add to Confluence.svg": 550,
	"./Github_logo.png": 551,
	"./Home Tab/Active users.svg": 336,
	"./Home Tab/Channels with Troopr.svg": 337,
	"./Home Tab/Checkins.svg": 552,
	"./Home Tab/Helpdesk.svg": 553,
	"./Home Tab/Hey Sam, welcome to Troopr.svg": 1270,
	"./Home Tab/Projects.svg": 554,
	"./Home Tab/Verified Jira account.svg": 338,
	"./Home Tab/Wiki.svg": 555,
	"./Home Tab/Workflow activities.svg": 339,
	"./Home Tab/check-circle.svg": 556,
	"./Home Tab/reports.svg": 557,
	"./Home Tab/welcome_to_troopr_card.svg": 558,
	"./Jira_logo.png": 245,
	"./applicationLink2.PNG": 1271,
	"./applicationlink.png": 1272,
	"./arrow-shape.png": 1273,
	"./as-appsumo-logo-blk.png": 532,
	"./assign.svg": 1274,
	"./audio_icon.png": 1275,
	"./bitbucket.svg": 1276,
	"./chat_extraction.svg": 1277,
	"./chevron_down.svg": 1278,
	"./chevron_up.svg": 1279,
	"./circular_troopr_logo.svg": 206,
	"./consumer.png": 1280,
	"./cross.svg": 1281,
	"./cross_white.svg": 1282,
	"./download.svg": 1283,
	"./emptyTaskProgress.svg": 1284,
	"./file_text.png": 1285,
	"./filter-sidebar-assignee.svg": 1286,
	"./filter-sidebar-checkmark.svg": 1287,
	"./filter-sidebar-close.svg": 1288,
	"./filter-sidebar-unassigned.svg": 1289,
	"./gantt_placeholder.png": 1290,
	"./gitLab.png": 1291,
	"./google_icon.svg": 666,
	"./image_icon.png": 1292,
	"./jira_cloud_site_url_example.jpeg": 559,
	"./jira_final_notification_setup.jpeg": 1293,
	"./jira_intial_notification_setup.jpeg": 1294,
	"./jira_server_site_url_example.jpeg": 560,
	"./jira_transparent.png": 1295,
	"./jira_white_logo.svg": 1296,
	"./kanban.svg": 1297,
	"./list.svg": 1298,
	"./logo.svg": 1299,
	"./no_notif.svg": 1300,
	"./options.svg": 1301,
	"./plus.svg": 1302,
	"./projectReportEmpty.svg": 1303,
	"./purple_arrow.svg": 1304,
	"./sentry.svg": 1305,
	"./shape-copy-13.svg": 1306,
	"./shape.svg": 1307,
	"./shape3.svg": 1308,
	"./slack-1.svg": 665,
	"./slack_logo.png": 561,
	"./slacklo.png": 1309,
	"./tada.png": 1310,
	"./task-sidebar-followers-selected.svg": 1311,
	"./task-sidebar-marked.svg": 1312,
	"./task_checked.svg": 1313,
	"./task_unchecked.svg": 1314,
	"./troopr-jira-configure-app-link.png": 1315,
	"./troopr_full_logo.svg": 533,
	"./troopr_guide.png": 1316,
	"./troopr_guide_7.svg": 1317,
	"./troopr_logo.png": 531,
	"./trooprlogo1.svg": 1318,
	"./undefined_icon.png": 1319,
	"./video_icon.png": 1320,
	"./webhook1.png": 1321,
	"./webhook2.png": 1322,
	"./zip_icon.png": 1323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1265;